import React, { useState, createContext } from "react";
import auth from './auth';

export const authContext = createContext({});

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(auth.user);
    const [idToken, setIdToken] = useState(auth.idToken);
    const [claim, setClaim] = useState(auth.claim);

    return (
        <authContext.Provider value={{
            user,
            setUser,
            idToken,
            setIdToken,
            claim,
            setClaim,
        }}>
            {children}
        </authContext.Provider>
    );
}

export default AuthProvider;